import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '@/admin_grapes/bill_send_records.js';

const CONFIRM_COLUMNS = [
  {
    prop: 'file',
    label: '凭证',
    renderCell: {
      component: 'upload',
      props: {
        accept: 'image/*,.csv,.pdf,.txt,.xlsx,.docx,.xls,.doc',
        type: ['image', 'csv', 'application/pdf', 'text/plain', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        clipboard: true,
        drag: true,
      }
    }
  }
];

export function buildBillSendRecordFilterColumns({ includeCustomer = true } = {}) {
  return filterColumnsExtend([
    includeCustomer && 'customer_id_eq',
    'state_eq',
  ].filter(Boolean));
}

export function buildBillSendRecordColumns({ type = 'index', includeCustomer = true } = {}) {
  return columnsExtend([
    type === 'show' && 'id',
    'send_method',
    'sent_at',
    'state',
    includeCustomer && 'customer',
    'sender',
    'confirmed_at',
    'confirmed_by',
    'confirmed_ip',
    'file',
    type === 'show' && 'created_at',
    type === 'show' && 'updated_at',
  ].filter(Boolean));
}

export function buildBillSendRecordFormColumns({ data = {}, type = 'new', includeCustomer = true } = {}) {
  return formColumnsExtend([
    includeCustomer && 'customer_id',
    'send_method',
    'sent_at',
  ].filter(Boolean), { data, type });
}

export function buildBillSendRecordActions(vm, { row }, { remove, reload }, { editAction } = {}) {
  const localEditAction = editAction
    ? editAction(row, { remove, reload })
    : {
        component: 'routeButton',
        props: {
          label: vm.$t('edit'),
          to: { name: 'bill_send_records.edit', params: { id: row.id } }
        }
      };

  return [
    row.state === 'pending' && localEditAction,
    row.can_confirm && {
      component: 'dialogFormButton',
      props: {
        label: '确认账单',
        columns: CONFIRM_COLUMNS,
        value: {},
        submitHandler: async (value) => {
          await vm.$autoLoading(vm.$request.put(`/bill_send_records/${row.id}/confirm`, { ...value }));
          vm.$message.success(vm.$t('operateSuccess'));
          reload();
        }
      }
    },
    row.can_reopen && {
      component: 'confirmButton',
      props: {
        label: '取消确认',
        can: 'bill_send_records.confirm',
        type: 'primary'
      },
      on: {
        confirm: async () =>  {
          await vm.$autoLoading(vm.$request.put(`/bill_send_records/${row.id}/reopen`));
          vm.$message.success(vm.$t('operateSuccess'));
          reload();
        }
      }
    }
  ].filter(Boolean);
}
